import * as actionTypes from "./actionTypes";
import {
  UserId, UserIdAction,
  LocationAction,
  Layer, LayersAction,
  BaseLayer, BaseLayersAction,
  FilterActiveAction,
  MapOpenedAction,
  DrawEnabledAction,
  ContactOpenedAction,
  ObjectClickAction
} from "./type";
import { Feature } from "ol";


export function getUserID(id: number) {

  return async (dispatch: (arg0: UserIdAction) => void) => {
    if (id) try {
      let newId: UserId = {
        id: id
      }

      const action: UserIdAction = {
        type: actionTypes.GET_USERID,
        user: newId
      }

      dispatch(action)

    } catch (err) {

    }
  }
}

export function setLocation(name: string) {
  return async (dispatch: (arg0: LocationAction) => void) => {
    if (name) try {
      let location = name;
      const action: LocationAction = {
        type: actionTypes.SET_LOCATION,
        location: location
      }
      dispatch(action)
    } catch (err) {
    }
  }
}

export function setLayers(layers: Array<Layer>) {
  return async (dispatch: (arg0: LayersAction) => void) => {
    if (layers) try {
      const action: LayersAction = {
        type: actionTypes.CHANGE_LAYERS,
        layers: layers
      }
      dispatch(action)
    } catch (err) {
    }
  }
}

export function setBaseLayers(baseLayers: Array<BaseLayer>) {
  return async (dispatch: (arg0: BaseLayersAction) => void) => {
    if (baseLayers) try {
      const action: BaseLayersAction = {
        type: actionTypes.CHANGE_BASE_LAYERS,
        baseLayers: baseLayers
      }
      dispatch(action)
    } catch (err) {
    }
  }
}

export function turnOffAllLayers() {
  return async (dispatch: (arg0: LayersAction) => void) => {
    try {
      const action: LayersAction = {
        type: actionTypes.TURN_OFF_ALL_LAYERS,
        layers: null
      }
      dispatch(action)
    } catch (err) {
    }
  }
}



export function setFilterActive(active: boolean) {
  return async (dispatch: (arg0: FilterActiveAction) => void) => {
    try {
      const action: FilterActiveAction = {
        type: actionTypes.SET_FILTER_ACTIVE,
        active: active
      }
      dispatch(action)
    } catch (err) {
    }
  }
}


export function setMapOpened(opened: boolean, coords: [number, number] | null = null) {
  return async (dispatch: (arg0: MapOpenedAction) => void) => {
    try {
      const action: MapOpenedAction = {
        type: actionTypes.SET_MAP_OPENED,
        opened: opened,
        coords: coords
      }
      dispatch(action)
    } catch (err) {
    }
  }
}


export function setDrawEnabled(enabled: boolean) {
  return async (dispatch: (arg0: DrawEnabledAction) => void) => {
    try {
      const action: DrawEnabledAction = {
        type: actionTypes.SET_DRAW_ENABLED,
        enabled: enabled
      }
      dispatch(action)
    } catch (err) {
    }
  }
}

export function setContactOpened(opened: boolean | string) {
  return async (dispatch: (arg0: ContactOpenedAction) => void) => {
    try {
      const action: ContactOpenedAction = {
        type: actionTypes.SET_CONTACT_OPENED,
        opened: opened
      }
      dispatch(action)
    } catch (err) {
    }
  }
}

export function setObjectClick(feature: Feature | null) {
  return async (dispatch: (arg0: ObjectClickAction) => void) => {
    try {
      const action: ObjectClickAction = {
        type: actionTypes.SET_OBJECT_CLICK,
        feature: feature
      }
      dispatch(action)
    } catch (err) {
    }
  }
}

export function complexActionForContact(dispatch: Function, state: boolean, info: string | undefined) {
  dispatch(setFilterActive(false));
  // SetDrawEnabled(false)
  dispatch(setObjectClick(null));
  dispatch(setContactOpened(info ? info : state));
}